import getEnv from '@/modules/shared/utils/env';
import router from '@/router';
import * as Sentry from '@sentry/vue';
import type { Vue } from '@sentry/vue/build/types/types';

const getSentryDsn = (): string => {
  const sentryDsn = getEnv('VUE_SENTRY_DSN');

  if (sentryDsn !== '{{VUE_SENTRY_DSN}}' && typeof sentryDsn === 'string' && sentryDsn) {
    return sentryDsn;
  }

  return 'https://2d98e71619c7448a92f61c6f3a58a7fc@o32227.ingest.us.sentry.io/5407071';
};

export const initSentry = (app: Vue) => {
  Sentry.init({
    app,
    dsn: getSentryDsn(),
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    environment: window.location.origin === 'https://stream.byteark.com' ? 'production' : 'development',
  });
};
